import { es } from 'vuetify/lib/locale'

export default {
  ...es,
  lang: "Español",
  
  login: "Iniciar sesión",
  logout: "Cerrar sesión",

  //User
  username: "Nombre de usuario",
  email: "Correo electrónico",
  password: "Contraseña",

  user: "Usuario",
  user_menu: {
    process_map_image: "Imagen Mapa Procesos",
    change_password: "Cambiar Contraseña",
  },

  inactivity_title: "AVISO DE INACTIVIDAD",
  check_inactivity_warning_1: "Su sesión está a punto de caducar. Si desea continuar en la página pulse Continuar.",
  check_inactivity_warning_2: "Segundos para desconexión automática: ",
  
  identify: "Identifícate",
  add: "Añadir",
  delete: "Eliminar",
  search_text: "Buscar...",
  loading: "Cargando...",
  select: "Seleccionar",
  select_all: "Seleccionar todos",
  limit: "Límite",
  type: "Tipo",
  confirm: "Sí",
  denny: "No",
  not_found: "No encontrado",
  text_new: "Nuevo",
  text_modify: "Modificado",
  text_equal:"Igual",
  text_legend:"Leyenda",
  max_file_size_reached: "Se ha alcanzado el tamaño máximo de los archivos del formulario (19Mb).\n Elimine algún archivo o reduzca su tamaño.",
  read: "Leer",
  all: "Todos",

  labels: {
    name: "Nombre",
    description: "Descripción",
    weight: "Peso",
    number: "Número",
    units: "Unidades",
    document: "Documento",
    report: "Informe",
    report_list: "Listado",
    parent_roles_inheritance: "Herencia de roles del padre",
  },

  dialog: {
    save: "Guardar",
    cancel: "Cancelar",
    send: "Enviar",
    clear: "Limpiar",
    delete: "Borrar",
    confirm: "Confirmar",
  },

  filters: {
    processes: {
      process: "Filtro de procesos",
      processes_selected: "Procesos seleccionados",
    },
    dates: {
      date_range: "Escoger rango de fechas",
      dates_selected: "Fechas seleccionadas",
      date_field: "Escoger Campo",
      date1_lower: "La fecha final no puede ser menor que la de inicio",
    },
    advanced: {
      filters: "Filtros",
      title: "Condiciones del filtro",
    },
    type: "Filtro de tipo",
  },

  week_days: {
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",

    short: {
      monday: "Lun",
      tuesday: "Mar",
      wednesday: "Mié",
      thursday: "Jue",
      friday: "Vie",
      saturday: "Sáb",
      sunday: "Dom",
    }
  },

  month_names: {
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre",
  },

  monthly: "Mensual",
  weekly: "Semanal",
  daily: "Diario",

  go_to_today: "Ir a Hoy",
  calendar_type: "Modo de visualización actual",
  current_day_interval: "Intervalo de días actual",

  no_process_map: "No hay ningún mapa de procesos configurado",
  required_field: "Campo requerido",
  duplicate_value: "El valor no es válido. Duplicado",
  copied: "Copiado",

  invalid_value: "Valor inválido",
  invalid_date: "Fecha inválida",
  invalid_hour: "Hora inválida",
  invalid_minute: "Minutos inválidos",
  invalid_negative_number: "No se admiten números negativos",
  bigger_than: "El valor debe ser mayor de",
  smaller_than: "El valor debe ser menor de",

  password_form: {
    current_password: "Contraseña",
    new_password: "Nueva contraseña",
    confirm_new_password: "Confirmar nueva contraseña",

    input_current_password: "Introducir contraseña actual",
    input_new_password: "Introducir nueva contraseña",
    reinput_new_password: "Reintroducir nueva contraseña",
    pattern_error: "Mín. 8 caracteres con al menos una letra mayúscula, un número y un carácter especial.",
    password_no_match: "Los campos no coinciden",
    password_different: "La nueva contraseña debe ser diferente de la anterior",
  },

  notifications: {
    title: "Notificaciones de usuario",
  },

  pagination: {
    page: "Elementos por página",
    page_mobile: "Página",
    of: "de",
  },

  explorer: {
    no_data: "No se han encontrado resultados",
    no_views: "No hay vistas disponibles",
  },

  views: {
    table: "Tabla",
    cards: "Tarjetas",
    calendar: "Calendario",
    charts: "Gráficos",
    processes: {
      tabs: {
        data: "Datos",
        permissions: "Permisos"
      },
      add_process: "Añadir proceso",
      edit_process: "Editar proceso",
      delete_process: "Eliminar proceso",
      add_permission: "Añadir permiso",
      edit_permission: "Editar permiso",
      delete_permission: "Eliminar permiso",
      process_fields: {
        process_id: "Id",
        internal_type: "Tipo de proceso interno",
        internal_type_placeholder: "Seleccione tipo de proceso interno",
        bp_reference: "Referencia interna",
        bp_reference_placeholder: "Introducir referencia interna del proceso",
        inherit_permissions: "Hereda permisos",
        inherit_permissions_placeholder: "Seleccione si el proceso hereda roles/permisos",
        reference: "Referencia",
        reference_placeholder: "Introducir referencia del proceso",
        name: "Nombre",
        name_placeholder: "Introducir nombre del proceso",
        process_type: "Tipo de proceso",
        process_type_placeholder: "Seleccionar tipo de proceso",
        description: "Descripción",
        description_placeholder: "Introducir descripción del proceso",
        entries: "Entradas",
        entries_placeholder: "Introducir entradas del proceso",
        outputs: "Salidas",
        outputs_placeholder: "Introducir salidas del proceso",
        activities: "Actividades",
        activities_placeholder: "Introducir actividades del proceso",
        objective: "Objetivo",
        objective_placeholder: "Introducir objetivo del proceso",
        scope: "Alcance",
        scope_placeholder: "Introducir alcance del proceso",
        process_roles_text: "ROLES DEL PROCESO",
        responsible_roles: "Roles responsables del proceso",
        responsible_roles_placeholder: "Seleccionar roles responsables del proceso",
        creator_roles: "Roles que pueden crear",
        creator_roles_placeholder: "Seleccionar roles que pueden crear QUnits que implementen el proceso",
        editor_roles: "Roles editor del proceso",
        editor_roles_placeholder: "Seleccionar roles que pueden ejecutar todas las transiciones de los QUnits que implementen el proceso",
        reader_roles: "Roles lectores del proceso",
        reader_roles_placeholder: "Roles que pueden leer todos los QUnits que implementen el proceso. Descarga PDF",
        original_document_reader_roles: "Roles lectores del proceso. Descargar original",
        original_document_reader_roles_placeholder: "Roles que pueden leer todos los QUnits que implementen el proceso. Descarga PDF/ORIGINAL.",
        visor_pdf_reader_roles: "Roles lectores del proceso. Solo visor PDF",
        visor_pdf_reader_roles_placeholder: "Roles que pueden leer todos los QUnits que implementen el proceso. Solo visor PDF",
        parent: "Padre",
      },
      permission_fields: {
        permission_id: "Id. Permiso",
        roles_allowed: "Roles autorizados",
        departments_allowed: "Departamentos autorizados",
      },
      process_types: {
       core: "Clave",
       strategic: "Estratégico",
       support: "De Soporte",
      },
      internal_type: {
        public: "Público",
        restricted: "Restringido",
      },
      standard: {
        add: "Añadir estándard",
        name_placeholder: "Introducir Nombre",
      },
    },
  },

  inputs: {
    directory: "Carpeta",
    current_file: "Archivo actual",
    file_too_big: "El tamaño debe ser menor de 20 MiB!",
    file_type_not_identified: "No se puede identificar el tipo de archivo",
    file_not_valid: "El archivo no es válido",
    email_invalid: "El correo electronico no es válido",
    start_space: "Tiene un espacio al principio",
    link_invalid: "El enlace no es válido",
  },

  indicators: {
    weight: "Peso",
    measure_type: "Seleccione el tipo de medida",
    new_measure: "Nueva medida",
    percentage: "Porcentaje",
    invalid_percentage: "Porcentaje inválido",
    indicator_label: "Indicador",
    new_measure_modal: "Medidas: Nueva medida",
    measures_types_names: {
      "category": "Categórica",
      "number": "Numérica",
      "indicator": "Sub-indicador",
    },
    variable_type: "Tipo de variable",
    allow_negative: "Permitir valores negativos",
    units_placeholder: "Nombre de la unidad. Ej: kg, m, l, kW/h...",
    num_types: {
      integer: "Entero",
      decimal: "Decimal",
    },
  },

  directory: {
    directory: "Carpeta",
    no_directory: "No se encontraron carpetas",
    add_directory: "Añadir carpeta",
    add_subdirectory: "Añadir subcarpeta",
    edit_directory: "Editar carpeta",
    delete_directory: "Borrar carpeta",
    father: "Padre",
    select_father: "Seleccione la carpeta padre",
    directory_name: "Nombre",
    select_parent_directory: "Seleccione la carpeta padre",
    not_able_to_delete: "No se puede borrar la carpeta",
    level: "Nivel",
    route: "Ruta",
  },

  footer: {
    contact: "Contacto",
    help: "Ayuda",
  },

  actions: {
    generic_download_evidence_options: {
      current_version: "Versión vigente",
      draft: "Borrador",
    },
    view_qunit: {
      data: "Datos",
    },
  },

  inlineboxes: {
    inlinebox_data: {
      copy_email: "Copiar código email",
      responsible: "Responsable",
    },
  },

  chips: {
    value: "Valor",
    process: "Proceso",
  },

  reports:{
    info:"Su listado se está generando ...",
    success: "El listado ha sido generado",
    error: "Error: no se pudo generar el listado",
  },

  indicator: {
    numbers: "Números",
    int: "enteros",
    float: "decimales",
    positive: "positivos",
    units: 'Unidades',
  },
};
